import styles from "@styles/containers/oraculo/oracle-drawer.module.scss";
import { useState } from "react";

import { Button, Hairline, Label, Radio, Select } from "@components";

import { VariableSchema } from "@containers/oraculo/VariableSchema";
import { TimeForm } from "./TimeForm";

export default ({ node, options = [], onSave, onRemove }) => {
  const [operand, setOperand] = useState(node.operand || "eq");
  const [value, setValue] = useState(node.value || options?.[0]?.value || null);
  const [range, setRange] = useState(node.range || {});

  const getFreshNode = () => {
    return {
      ...node,
      operand,
      value,
      range,
      label: options.find((o) => o.value == value)?.label || null,
    };
  };

  const validate = () => {
    if (!operand || !value) {
      return false;
    }

    return true;
  };

  return (
    <>
      <div className={styles.scrollContainer}>
        <div className={styles.card}>
          <Label>Defina o uso desta variável:</Label>
          <Hairline solid className="mt-5 mb-20" />
          <Radio
            family="variableType"
            className="mb-10"
            value="eq"
            checked={operand}
            readOnly
          >
            Igual a
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="neq"
            checked={operand}
            readOnly
          >
            Diferente de
          </Radio>
        </div>

        <div className={styles.card}>
          <Label>Determine o valor:</Label>
          <Hairline solid className="mt-10 mb-20" />
          <div className={styles.value}>
            {options.find((o) => o.value == value)?.label}
          </div>
        </div>

        <div className={styles.card}>
          <Label>Faixa de tempo:</Label>
          <Hairline solid className="mt-10 mb-20" />
          <TimeForm range={range} onChange={(r) => setRange(r)} />
        </div>
      </div>
    </>
  );
};
